import * as XLSX from 'xlsx';
import Papa from 'papaparse';
import moment from 'moment';
import { PrelimRow } from './PreliminaryNoticesReporting';

type ColumnHeader = { key: keyof PrelimRow; label: string };

// MM-DD-YYYY stamp for export file names (dashes since "/" is a path separator).
const getExportDateStamp = () => moment().format('MM-DD-YYYY');

const formatRowForExport = (row: PrelimRow, columns: ColumnHeader[]): Record<string, string> => {
  const formatted: Record<string, string> = {};
  columns.forEach((header) => {
    formatted[header.label] = row[header.key] ?? '';
  });
  return formatted;
};

export const exportToXlsx = (rows: PrelimRow[], columns: ColumnHeader[]) => {
  const formattedRows = rows.map((r) => formatRowForExport(r, columns));
  const worksheet = XLSX.utils.json_to_sheet(formattedRows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Preliminary Notices Report');
  XLSX.writeFile(workbook, `preliminary-notices-report-${getExportDateStamp()}.xlsx`);
};

export const exportToCsv = (rows: PrelimRow[], columns: ColumnHeader[]) => {
  const formattedRows = rows.map((r) => formatRowForExport(r, columns));
  const csv = Papa.unparse(formattedRows, { columns: columns.map((c) => c.label) });
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `preliminary-notices-report-${getExportDateStamp()}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
